var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { getIntersectionObserverConstructor } from "sb-resp-lib";
import { Loader } from "../Loader";
var defaultsOptions = {
    rootMargin: "0px",
    threshold: .01
};
var Img = /** @class */ (function (_super) {
    __extends(Img, _super);
    function Img(props) {
        var _this = _super.call(this, props) || this;
        _this.update = function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    _this.loadImg();
                    _this.observer.disconnect();
                }
            });
        };
        _this.refRoot = React.createRef();
        var OBS = getIntersectionObserverConstructor();
        _this.observer = new OBS(_this.update, __assign({}, defaultsOptions, props.lazyOptions));
        _this.state = {
            isLoading: true,
            imgStyle: {
                width: _this.props.width,
                height: _this.props.height
            }
        };
        return _this;
    }
    Img.prototype.loadImg = function () {
        var img = new Image();
        img.onload = this.onLoad.bind(this, img);
        img.onerror = this.onError.bind(this);
        img.src = this.props.src;
        return img;
    };
    Img.prototype.getValue = function (ref, fallback) {
        return ref || fallback;
    };
    Img.prototype.onLoad = function (img) {
        var imgWidth = this.getValue(this.props.width, img.width);
        var imgHeight = this.getValue(this.props.height, img.height);
        this.loadImgStyle(imgWidth, imgHeight, this.props.src);
        this.changeLoading(false);
    };
    Img.prototype.onError = function () {
        var imgWidth = this.props.width;
        var imgHeight = this.props.height;
        this.loadImgStyle(imgWidth, imgHeight, this.props.fallbackSrc);
        this.changeLoading(false);
    };
    Img.prototype.loadImgStyle = function (width, height, imgUrl) {
        this.setState({
            imgStyle: {
                width: width,
                height: height,
                backgroundImage: "url(\"" + imgUrl + "\")",
            }
        });
    };
    Img.prototype.changeLoading = function (state) {
        this.setState({ isLoading: state });
    };
    Img.prototype.componentDidMount = function () {
        if (this.refRoot.current) {
            this.observer.observe(this.refRoot.current);
        }
    };
    Img.prototype.render = function () {
        return (React.createElement("sb-img", { className: this.props.className, style: this.state.imgStyle, ref: this.refRoot }, this.state.isLoading && React.createElement(Loader, null)));
    };
    return Img;
}(React.Component));
export { Img };
//# sourceMappingURL=Img.js.map